import React from 'react';
import { Table, TableHead, TableRow, TableBody, TableCell, TextField } from '@mui/material';

const cellSx = {
  borderBottom: 'none',
};

const RescueSizingTable = ({ rescueSizeData, dataUpdated }) => (
  <Table>
    <TableHead>
      <TableRow>
        <TableCell align="center" sx={cellSx}>
          Size
        </TableCell>
        <TableCell align="center" sx={cellSx}>
          Current
        </TableCell>
        <TableCell align="center" sx={cellSx}>
          Recalculated
        </TableCell>
      </TableRow>
    </TableHead>

    <TableBody>
      {rescueSizeData.map((row, index) => (
        <TableRow key={index}>
          <TableCell align="center" sx={cellSx}>{row.size}</TableCell>
          <TableCell align="center" sx={cellSx}>
            <TextField
              size="small"
              variant="outlined"
              value={row.current}
              InputProps={{
                readOnly: true,
              }}
              style={{ width: 70 }}
            />
          </TableCell>
          <TableCell align="center" sx={cellSx}>
            <TextField
              size="small"
              variant="outlined"
              value={row.recalculated}
              disabled={dataUpdated}
              InputProps={{
                readOnly: true,
              }}
              style={{ width: 70 }}
            />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default RescueSizingTable;
